import {useSelector} from 'react-redux';

/**
 * The stored wire transfer details (IBAN/BIC) for the current company's account.
 * @returns {Object}
 */
export const useWireDetails = () => useSelector(state => state.transaction?.wireDetails ?? {});
